'use client';
import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId:process.env.REACT_APP_UI_CLIENT_ID,// 'dfa2df90-13c5-48f1-920e-5ecbad3b1f56',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_UI_Authority}/v2.0`,
    redirectUri: '/',
    postLogoutRedirectUri: '/login',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error: console.error(message); break;
          case LogLevel.Info: console.info(message); break;
          case LogLevel.Verbose: console.debug(message); break;
          case LogLevel.Warning: console.warn(message); break;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    "email",
    process.env.REACT_APP_UI_API_Audience,
  ],
};
//clientId: '3a9687cf-e871-4852-acc9-c8f5163ab712',
// "api://bcaf8de6-b40d-4ca9-89f2-48ef57fa1824/all"